import React, { FC } from 'react';
import classes from '../../styles/index.module.scss';
import classNames from 'classnames';
import { ErrorBoundary } from '../../../../../../ReactSharedScripts/components/ErrorBoundary';
import { isNullOrUndefined } from '../../../../../../ReactSharedScripts/predicates/type';
import { ModalFooterButtonsProps } from '../../../../../../ReactSharedScripts/components/ModalBox/types';

export const FooterButtons: FC<ModalFooterButtonsProps> = ({ leftButtons, rightButtons, className }) => {
	const componentClasses = classNames(classes.footerButtons, className);

	const getButtons = (buttons) => {
		return React.Children.map(buttons, (child) => {
			if (isNullOrUndefined(child)) {
				return null;
			}

			return React.cloneElement(child, {
				size: 'small',
				...child.props,
				className: classNames(classes.footerButton, child.props.className),
			});
		});
	};

	return (
		<ErrorBoundary>
			<div className={componentClasses}>
				<div className={classes.footerButtonsLeft}>{getButtons(leftButtons)}</div>
				<div className={classes.footerButtonsRight}>{getButtons(rightButtons)}</div>
			</div>
		</ErrorBoundary>
	);
};
